/**
 @ngdoc directive
 @name timesheetOverlapValidation

 @description
 used within _listFormTabular to validate timesheet inputs do not overlap.
 Individual inputs must set ng-style color red based upon overlap
 */

(function() {
  'use strict'

  const timesheetOverlapValidation = () => {
    return {
      restrict: 'A',
      link: ($scope, $element) => {
        const index = $element[0].dataset.index
        const STR_WRAPPER = 'timesheetStartTimeWrapper_'
        const LOOKUP = {
          warn: {
            innerText: 'End time is set before the start time - the end time will be recognised as the following day',
            id: 'timesheetWarnTag_',
            color: '#b38a0f',
          },
          error: {
            innerText: 'Timesheet hours overlap, please review',
            id: 'timesheetErrorTag_',
            color: '#ac2925',
          },
        }

        $scope.$watch(
          'formModel.timeRecordHourlyList[' + index + '].startTime',
          () => {
            checkForOverlaps()
          },
        )
        $scope.$watch(
          'formModel.timeRecordHourlyList[' + index + '].endTime',
          () => {
            checkForOverlaps()
          },
        )

        const createTag = (idx, type) => {
          const errorTag = document.createElement('span')
          errorTag.style.position = 'absolute'
          errorTag.style.width = '500px'
          errorTag.innerText = LOOKUP[type].innerText
          errorTag.id = LOOKUP[type].id + idx
          errorTag.style.color = LOOKUP[type].color
          return errorTag
        }

        const createDate = (strDate, dateForTime) => {
          return dateFns.set(dateFns.parse(strDate, 'dd/MM/yyyy', new Date()), {
            hours: dateFns.getHours(dateForTime),
            minutes: dateFns.getMinutes(dateForTime),
            seconds: 0,
            milliseconds: 0,
          })
        }

        const checkForOverlaps = () => {

          let timesheetRows = Object.values($scope.formModel.timeRecordHourlyList)

          timesheetRows = timesheetRows.map(row => {

            const isValid = dateFns.isValid(row.startTime) && dateFns.isValid(row.endTime)

            row.interval = isValid ? {
              start: createDate(row.strDate, row.startTime),
              end: createDate(row.strDate, row.endTime),
            } : null

            row.endBeforeStart = null

            if (row.interval != null) {
              row.endBeforeStart = !dateFns.isBefore(row.interval.start, row.interval.end) && !dateFns.isEqual(row.interval.start, row.interval.end)
              if (row.endBeforeStart) row.interval.end = dateFns.addDays(row.interval.end, 1)
            }

            return row
          })

          const intervals = timesheetRows.map(row => row.interval)

          timesheetRows = timesheetRows.map((row, i) => {
            row.overlap = row.interval == null ? null : intervals.some((interval, j) => {
              if (i === j) return false
              if (interval == null) return false
              return dateFns.areIntervalsOverlapping(interval, row.interval)
            })
            return row
          })

          timesheetRows.forEach((row, idx) => {
            clear(idx, 'error')
            clear(idx, 'warn')
            if (row.overlap) {
              display(idx, 'error')
            } else if (row.endBeforeStart) {
              display(idx, 'warn')
            }
          })
        }

        const clear = (idx, type) => {
          const wrapper = document.getElementById(STR_WRAPPER + idx)
          wrapper.style.height = ''

          const id = LOOKUP[type].id + idx
          const tag = document.getElementById(id)

          if (tag) wrapper.removeChild(tag)
        }

        const display = (idx, type) => {
          const wrapper = document.getElementById(STR_WRAPPER + idx)
          wrapper.style.height = '40px'
          wrapper.appendChild(createTag(idx, type))
        }
      },
    }
  }

  angular
    .module('app')
    .directive('timesheetOverlapValidation', timesheetOverlapValidation)
// eslint-disable-next-line semi
})();
